import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import { H1, H2, H3, A, P } from "commons";

import { routes } from "../../helpers/RouteHelpers";
import { GoLogo, GlobalMsg, LiveChat, Support } from "../../components";
import { forgotPassword } from "../../components/DataOperations";
import { ClientSupportLink } from "./PlatformLinks";
import {
    AuthButton,
    AuthBlock,
    AuthContentHolder,
    AuthTextInput,
    ButtonLoading,
    Form
} from "./AuthComponents";

export function ForgottenPassword({ isLoading }) {
    const [username, setUsername] = useState("");

    const submitForgotPassword = e => {
        e.preventDefault();
        forgotPassword(username);
    };

    return (
        <AuthContentHolder>
            <GlobalMsg />
            <AuthBlock>
                <GoLogo />
                <H1 secondary>Reset login details</H1>

                <Instructions data-testid="forgotten-password-instructions">
                    <Header secondary>Forgot your password or locked your account?</Header>
                    <P>Please enter your username and click &apos;submit&apos;.</P>
                    <P>
                        An email will be sent to you shortly with instructions to reset your
                        password.
                    </P>

                    <ForgottenUsername>
                        Forgot your username?{" "}
                        <A
                            href={`${ClientSupportLink}#lost-registration`}
                            rel="noopener noreferrer"
                            target="_blank"
                            aria-label="lost username instructions"
                            underline
                            secondary
                        >
                            Click here.
                        </A>
                    </ForgottenUsername>
                </Instructions>
                <Form onSubmit={submitForgotPassword}>
                    <AuthTextInput
                        data-testid="forgotten-password-username"
                        label="Username"
                        value={username}
                        type="text"
                        onChange={e => setUsername(e.target.value)}
                        autoCapitalize="none"
                    />

                    <ButtonLoading displayWhen={!isLoading}>
                        <AuthButton data-testid="submit-button" disabled={!username}>
                            Submit
                        </AuthButton>
                    </ButtonLoading>
                </Form>
                <BackLink textAlign="center" secondary>
                    <Link to={routes.public.login()} data-testid="back-to-login-link">
                        Back to login?
                    </Link>
                </BackLink>
                <Support />
                <LiveChat data-testid="live-chat" />
            </AuthBlock>
        </AuthContentHolder>
    );
}

const Instructions = styled.section`
    text-align: initial;
    padding: 0 0.75em;
    margin-bottom: 2rem;
    width: 100%;
`;

const Header = styled(H2)`
    font-size: 1.125rem;
`;

const BackLink = styled(H3)`
    cursor: pointer;
`;

const ForgottenUsername = styled.p`
    margin-top: 1em;
`;

ForgottenPassword.propTypes = {
    isLoading: PropTypes.bool
};
